import request from '@/utils/request'
export default {
  getTotalNum(params) {
    return request.get('/workBusinessTimeAxis/projectTotal', { params })
  },
  getBeingItemNum(params) {
    return request.get('/workBusinessTimeAxis/projectProcessIngByMonth', { params })
  },
  getDelayRatio(params) {
    return request.get('/workBusinessTimeAxis/projectDelayByMonth', { params })
  },
  getPassRatio(params) {
    return request.get('/workTaskStatistics/acceptPassingRate', { params })
  },
  getAverCycle(params) {
    return request.get('/workBusinessTimeAxis/projectAvgTimeByMonth', { params })
  },
  getChart1(params) {
    return request.get('/workBusinessTimeAxis/projectProcessByMonth', { params })
  },
  getChart2(params) {
    return request.get('/workTaskStatistics/overdueTask', { params })
  },
  getChart3(params) {
    return request.get('/workTaskStatistics/teamTaskStatistics', { params })
  },
  getChart4(params) {
    return request.get('/workTaskStatistics/teamRectification', { params })
  },
  getChart5(params) {
    return request.get('/workTaskStatistics/inspectionFrequency', { params })
  },
  getChart6(params) {
    return request.get('/workBusinessTimeAxis/projectProcess', { params })
  },
  getChart7(params) {
    return request.get('/workTaskStatistics/dangerRate', { params })
  },
  getChart8(params) {
    return request.get('/workTaskStatistics/avgRectificationPeriod', { params })
  },
  getChart9(params) {
    return request.get('/workTaskStatistics/qualityQualificationRate', { params })
  },
  getCharts1(params) {
    return request.get('/workTaskStatistics/taskMonitoring', { params })
  },
  getCharts2(params) {
    return request.get('/workBusinessTimeAxis/projectProcessStat', { params })
  },
  getCharts3(params) {
    return request.get('/workTaskStatistics/planCompletedRate', { params })
  },
  getCharts4(params) {
    return request.get('/workBusinessTimeAxis/projectAvgTimes', { params })
  },
  getCharts5(params) {
    return request.get('/workBusinessTimeAxis/projectMaterials', { params })
  },
  getCharts6(params) {
    return request.get('/workBusinessTimeAxis/projectProcessByStatus', { params })
  }
}
